export default __webpack_public_path__ + "static/lp-bnr-9fd734f4d5927e2f9f81c65b37ee8980.avif";